/**
 * PHOTO CATEGORIES
 * Constants for photo categorization
 */

export const PHOTO_CATEGORIES = [
  { value: 'overview', label: 'Overview / Wide Shot', icon: '📷' },
  { value: 'existing', label: 'Existing Condition', icon: '🔍' },
  { value: 'damage', label: 'Damage / Issue', icon: '⚠️' },
  { value: 'access', label: 'Access / Logistics', icon: '🚪' },
  { value: 'utility', label: 'Utility / Mechanical', icon: '⚙️' },
  { value: 'detail', label: 'Detail / Close-up', icon: '🔬' },
  { value: 'reference', label: 'Reference / Inspiration', icon: '💡' },
];

export const getPhotoCategory = (value) => {
  return PHOTO_CATEGORIES.find(c => c.value === value) || PHOTO_CATEGORIES[0];
};

export default { PHOTO_CATEGORIES, getPhotoCategory };
